import React from 'react';
import cn from 'clsx';
import styles from './styles.module.scss';
import Card from '@components-clean/core/card';
import { FilterUIConfigType } from '@components-clean/core/study-data-filter/study-data-filter.interfaces';
import CountrySelector from '@pages-clean/central-monitoring/components/country-selector';
import DatasetSelectionButton from '@pages-clean/central-monitoring/components/dataset-selection-button/dataset-selection-button';
import { FilterActions } from '@pages-clean/central-monitoring/components/filter-actions/filter-actions';
import SiteSelector from '@pages-clean/central-monitoring/components/site-selector';
import DatasetFilterSelector from '@pages-clean/subject-monitoring/components/dataset-filter-selector';

interface IActionsBarProps {
    studyRef: string;
    datasetId: number;
    dataViewConfigId?: string;
    datasetSelector?: boolean;
    siteSelector?: boolean;
    filterActions?: FilterUIConfigType;
    className?: string;
    datasetDropdownSelector?: boolean;
    countrySelector?: boolean;
}

const ActionsBar = ({
    studyRef,
    datasetId,
    dataViewConfigId,
    datasetSelector,
    siteSelector,
    filterActions,
    className,
    datasetDropdownSelector,
    countrySelector,
}: IActionsBarProps) => {
    return (
        <Card
            data-testid="data-view-action-bar"
            className={cn('actions-bar', className, styles.actionBar)}
            padding="none"
        >
            <div className="k-d-flex k-w-full" style={{ gap: '14px' }}>
                {datasetSelector && (
                    <div className="k-d-flex" style={{ gap: '7px' }}>
                        {datasetSelector && <DatasetSelectionButton />}
                    </div>
                )}
                {siteSelector && <SiteSelector />}
                {countrySelector && <CountrySelector />}
                {datasetDropdownSelector && <DatasetFilterSelector />}
                {filterActions && (
                    <div className="k-d-flex k-justify-content-between k-w-full k-gap-1">
                        <FilterActions
                            studyRef={studyRef}
                            datasetId={datasetId}
                            dataViewConfigId={dataViewConfigId}
                            type={filterActions}
                        />
                    </div>
                )}
            </div>
        </Card>
    );
};

export default ActionsBar;
